// ExpiredRow.jsx
import { Button, Chip, Paper, Stack, Typography } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import moment from 'moment'

const ExpiredRow = ({ item, onRemove }) => {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 1,
        border: '1px solid',
        borderColor: 'error.light',
        bgcolor: 'rgba(227, 37, 37, 0.05)',
      }}
    >
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        alignItems={{ xs: 'stretch', md: 'center' }}
        justifyContent="space-between"
        gap={1}
      >
        <Stack direction="row" alignItems="center" gap={1} flexWrap="wrap">
          <ErrorOutlineIcon color="error" fontSize="small" />
          <Typography fontWeight={700}>{item.name}</Typography>
          {item.size && (
            <Typography color="text.secondary">{item.size}</Typography>
          )}
          <Chip
            size="small"
            color="error"
            label={`Expired ${moment(item.expiryDate).format('DD/MM/YYYY')}`}
          />
        </Stack>
        <Button
          color="error"
          variant="outlined"
          onClick={() => onRemove(item)}
          size="small"
          startIcon={<DeleteOutlineIcon />}
        >
          Remove expired item
        </Button>
      </Stack>
    </Paper>
  )
}

export default ExpiredRow
